import { Card, Accordion } from 'react-bootstrap';
import { IoIosMenu } from "react-icons/io";

const ServiceCard = ({ title, details }) => {
    return (
        <Card className="service-card h-100 rounded-4">
            <Card.Body className='p-3 rounded-4'>
                {details ? (
                    <Accordion flush className='rounded-4'>
                        <Accordion.Item eventKey="0" className='rounded-4'>
                            <Accordion.Button className='p-0 rounded-4 d-flex align-items-center gap-3'>
                                <div aria-hidden="true" className='service-icon flex-shrink-0'>
                                    <IoIosMenu />
                                </div>
                                <h5 className='fw-semibold fs-6 mb-0'>{title}</h5>
                            </Accordion.Button>
                            <Accordion.Body className='p-2 pt-3'>{details}</Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                ) : null}
            </Card.Body>
        </Card>
    );
};

export default ServiceCard;
